<template>
	<div class="home-page">
		<!-- Hero 主题区 -->
		<Theme></Theme>

		<!-- 核心服务卡片 -->
		<section class="section-services">
			<div class="section-container">
				<div class="services-grid">
					<div class="service-card" v-for="service in services" :key="service.title" @click="handleRoute(service.href)">
						<div class="service-icon" :style="{ background: service.gradient }">
							<i :class="service.icon"></i>
						</div>
						<h3 class="service-title">{{ service.title }}</h3>
						<p class="service-desc">{{ service.desc }}</p>
						<div class="service-footer">
							<span class="service-stats">{{ service.stats }}</span>
							<span class="service-link">立即体验 <i class="el-icon-arrow-right"></i></span>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 热门标准 -->
		<section class="section-hot">
			<div class="section-container">
				<div class="hot-header">
					<div class="hot-title-row">
						<!-- <i class="el-icon-s-promotion hot-title-icon"></i> -->
						 <i class="iconfont icon-fire hot-title-icon"></i>
						<div>
							<h2>热门标准</h2>
							<p>热门标准与法规图书</p>
						</div>
					</div>
					<!-- <el-button class="hot-view-all" type="text" @click="$router.push('/index/StandardsList')"> 查看全部 <i class="el-icon-arrow-right"></i> </el-button> -->
				</div>
				<div class="hot-list">
					<div class="hot-list-item" v-for="(book, index) in hotBooks" :key="book.id">
						<a :href="getBookHref(book)" target="_blank" class="hot-list-item-link" :title="book.standardCode ? book.standardCode + ' ' + book.standardName : book.standardName">
							<div class="hot-list-rank" :class="'rank-' + (index + 1)">{{ index + 1 }}</div>
							<div class="hot-list-body">
								<div class="hot-list-title-row">
									<h3 class="hot-list-title">{{ book.standardCode ? book.standardCode + ' ' + book.standardName : book.standardName }}</h3>
									<span class="hot-list-badge" v-if="book.standardTypeName">{{ book.standardTypeName }}</span>
								</div>
								<p class="hot-list-desc">{{ book.headAgency || book.implementAgency || book.issueAgency }}</p>
								<time class="hot-list-impl-date" v-if="book.effectiveDate" :datetime="book.effectiveDate">实施时间：{{ book.effectiveDate }}</time>
							</div>
							<span class="hot-list-btn">查看详情 <i class="el-icon-arrow-right"></i></span>
						</a>
					</div>
				</div>
			</div>
		</section>

		<!-- 新闻资讯 -->
		<section class="section-news">
			<div class="section-container">
				<div class="news-header">
					<div class="news-title-row">
						<i class="iconfont icon-xinwenzixun news-title-icon"></i>
						<div>
							<h2>新闻资讯</h2>
							<p>行业动态 · 政策解读 · 标准更新</p>
						</div>
					</div>
					<el-button class="hot-view-all" type="text" @click="$router.push('/NewsList')"> 查看全部 <i class="el-icon-arrow-right"></i> </el-button>
				</div>
				<div class="news-list">
					<div class="news-list-item" v-for="item in newsList" :key="item.id">
						<a :href="getNewsHref(item)" class="news-list-item-link">
							<i class="el-icon-document news-list-icon"></i>
							<span class="news-list-title">{{ item.newsTitle }}</span>
							<time class="news-list-time" :datetime="item.createTime">{{ item.createTime }}</time>
						</a>
					</div>
				</div>
			</div>
		</section>

		<!-- 平台数据统计 -->
		<section class="section-stats">
			<div class="section-container">
				<div class="stats-box">
					<div class="stats-header">
						<h2>平台数据</h2>
						<p>服务特种设备行业多年，值得信赖</p>
					</div>
					<div class="stats-grid">
						<div class="stat-item" v-for="stat in stats" :key="stat.label">
							<i :class="stat.icon"></i>
							<div class="stat-value">{{ stat.value }}</div>
							<div class="stat-label">{{ stat.label }}</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 为什么选择我们 -->
		<section class="section-why">
			<div class="section-container">
				<div class="why-header">
					<h2>为什么选择我们</h2>
					<p>专业、可信、高效的特种设备合规服务</p>
				</div>
				<div class="why-grid">
					<div class="why-card" v-for="item in whyUs" :key="item.title">
						<div class="why-icon">
							<i :class="item.icon"></i>
						</div>
						<h3>{{ item.title }}</h3>
						<p>{{ item.desc }}</p>
					</div>
				</div>
			</div>
		</section>

		<!-- 立即开始您的合规之旅 -->
		<section class="section-cta">
			<div class="section-container">
				<div class="cta-box">
					<div class="cta-content">
						<h2>立即开始您的合规之旅</h2>
						<p>注册即可享用免费试用，浏览正版标准图书，体验AI服务</p>
						<div class="cta-actions">
							<el-button class="cta-btn-primary" round size="medium" @click="openRegister"> <i class="el-icon-user-solid"></i>个人用户注册 </el-button>
							<el-button class="cta-btn-primary" round size="medium" @click="$router.push('/ApplyAccount')"> <i class="el-icon-user-solid"></i> 申请企业账号 </el-button>
							<!-- <el-button class="cta-btn-primary" round size="medium" @click="$router.push('/Download')"> <i class="el-icon-download"></i> App 下载 </el-button> -->
							<el-button class="cta-btn-secondary" round size="medium" @click="$router.push('/Version')"> <i class="el-icon-medal"></i> 会员权益 </el-button>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 友情链接 -->
		<FriendLink></FriendLink>
	</div>
</template>

<script>
	import Theme from './components/Theme.vue';
	import FriendLink from './components/FriendLink.vue';
	// import { newsList } from '@/views/News/newsData.js';
	import { mapActions, mapGetters } from 'vuex';
	import { getQuerySuggestStandard } from '@/api/standards/home';
	import { getStandardType } from '@/api/standards/search';
	import { getNewsList } from '@/api/news/news';

	export default {
		data() {
			return {
				services: [
					{
						icon: 'el-icon-reading',
						title: '法规标准库（正版商城）',
						desc: '特种设备行业标准、法规、培训教材全品类覆盖',
						href: '/StandardsList',
						gradient: 'linear-gradient(135deg, #22c55e, #059669)',
						stats: '10万+ 图书'
					},
					{
						icon: 'iconfont icon-aliwangwang-o',
						title: 'AI法规问答',
						desc: '智能问答、法规检索、案例解读，让合规更简单',
						href: '/AI',
						gradient: 'linear-gradient(135deg, #3b82f6, #4f46e5)',
						stats: '24/7 在线服务'
					},
					{
						icon: 'el-icon-folder-opened',
						title: '资料库管理',
						desc: '支持自建法规标准清单、上传分类管理内部资料，并让 AI 基于选定书单进行精准检索与专业问答',
						href: '/BookCenter/BuyList',
						gradient: 'linear-gradient(135deg, #f97316, #ef4444)',
						stats: '大空间 + 多文件格式'
					}
				],
				stats: [
					{ icon: 'el-icon-reading', value: '100，000+', label: '正版图书' },
					{ icon: 'el-icon-search', value: '300，000+', label: '标准信息' },
					{ icon: 'el-icon-user-solid', value: '16,900+', label: '企业客户' },
					{ icon: 'el-icon-circle-check', value: '99.9%', label: '服务可用性' }
				],
				whyUs: [
					{ icon: 'el-icon-circle-check', title: '正版授权', desc: '所有图书均为正版授权，品质保证' },
					{ icon: 'el-icon-lightning', title: '高效便捷', desc: 'AI智能服务，快速响应您的需求' },
					{ icon: 'el-icon-trophy', title: '专业可靠', desc: '深耕行业十余年，专业值得信赖' },
					{ icon: 'el-icon-refresh', title: '持续更新', desc: '法规标准实时更新，紧跟政策' }
				],
				standardTypeList: [],
				newsList: [],
				hotBooks: [
					{
						id: 1
						// img: require('@/assets/images/booklist/book-img01.png'),
						// title: 'GB/T 150-2011 压力容器',
						// desc: '全国锅炉压力容器标准化技术委员会',
						// category: '安全技术规范',
						// price: '128.00',
						// originPrice: '198.00',
						// badge: '国家标准',
						// implDate: '2012-03-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 2
						// img: require('@/assets/images/booklist/book-img02.png'),
						// title: 'TSG 21-2016 固定式压力容器安全技术监察规程',
						// desc: '国家质量监督检验检疫总局',
						// category: '法规汇编',
						// price: '168.00',
						// originPrice: '258.00',
						// badge: '安全规程',
						// implDate: '2016-10-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 3
						// img: require('@/assets/images/booklist/book-img03.png'),
						// title: '特种设备作业人员考核导则',
						// desc: '国家市场监督管理总局',
						// category: '培训教材',
						// price: '98.00',
						// originPrice: '',
						// badge: '培训教材',
						// implDate: '2020-06-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 4
						// img: require('@/assets/images/booklist/bookshelf.png'),
						// title: 'JB/T 4732-1995 钢制压力容器',
						// desc: '机械工业部',
						// category: '法规手册',
						// price: '68.00',
						// originPrice: '89.00',
						// badge: '行业标准',
						// implDate: '1995-10-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 5
						// img: require('@/assets/images/booklist/book-img01.png'),
						// title: 'GB 5768-2022 道路交通标志',
						// desc: '交通运输部',
						// category: '国家标准',
						// price: '156.00',
						// originPrice: '220.00',
						// badge: '国家标准',
						// implDate: '2022-10-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 6
						// img: require('@/assets/images/booklist/book-img02.png'),
						// title: 'TSG 08-2017 特种设备使用管理规则',
						// desc: '国家市场监督管理总局',
						// category: '法规汇编',
						// price: '128.00',
						// originPrice: '180.00',
						// badge: '安全规程',
						// implDate: '2017-08-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 7
						// img: require('@/assets/images/booklist/book-img03.png'),
						// title: 'GB/T 3811-2008 起重机设计规范',
						// desc: '全国起重机械标准化技术委员会',
						// category: '国家标准',
						// price: '185.00',
						// originPrice: '260.00',
						// badge: '国家标准',
						// implDate: '2008-08-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 8
						// img: require('@/assets/images/booklist/bookshelf.png'),
						// title: 'TSG T7001-2009 电梯监督检验和定期检验规则',
						// desc: '国家质量监督检验检疫总局',
						// category: '安全规程',
						// price: '138.00',
						// originPrice: '196.00',
						// badge: '安全规程',
						// implDate: '2009-12-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 9
						// img: require('@/assets/images/booklist/book-img01.png'),
						// title: 'GB/T 19001-2016 质量管理体系要求',
						// desc: '国家标准化管理委员会',
						// category: '管理体系',
						// price: '88.00',
						// originPrice: '128.00',
						// badge: '国家标准',
						// implDate: '2017-07-01',
						// href: '/BookCenter/BuyList'
					},
					{
						id: 10
						// img: require('@/assets/images/booklist/book-img02.png'),
						// title: 'GB/T 12241-2021 安全阀实用选型规定',
						// desc: '全国阀门标准化技术委员会',
						// category: '国家标准',
						// price: '108.00',
						// originPrice: '156.00',
						// badge: '国家标准',
						// implDate: '2021-07-01',
						// href: '/BookCenter/BuyList'
					}
				]
			};
		},
		computed: {
			// newsList() {
			// 	return newsList.slice(0, 10);
			// },
			...mapGetters('User', ['uisLogin'])
		},
		created() {
			this.getNewsList();
			this.getQuerySuggestStandard();
		},
		updated() {
			// 数据更新后重新注入结构化数据
			this.injectHotBooksSchema();
			this.injectNewsSchema();
		},
		methods: {
			// 获取新闻列表
			async getNewsList() {
				const res = await getNewsList({ pageSize: 10, pageNum: 1 });
				if (res.code === 200) {
					this.newsList = res.data.rows || [];
					console.log(this.newsList);
				} else {
					console.log(res.msg);
				}
			},

			//标准类型列表
			async getStandardType() {
				const res = await getStandardType();
				if (res.code === 200) {
					this.standardTypeList = res.data || [];
				} else {
					console.log(res.msg);
				}
			},

			async getQuerySuggestStandard() {
				const [typeRes, suggestRes] = await Promise.all([getStandardType(), getQuerySuggestStandard()]);

				if (typeRes.code === 200) {
					this.standardTypeList = typeRes.data || [];
				} else {
					console.log(typeRes.msg);
				}

				if (suggestRes.code === 200) {
					const rows = suggestRes.data.rows || [];
					// 根据 standardTypeList formatter standardTypeName
					rows.forEach(item => {
						if (item.standardType && this.standardTypeList.length) {
							const found = this.standardTypeList.find(t => t.id === item.standardType);
							item.standardTypeName = found ? found.typeName : '';
						}
					});
					this.hotBooks = rows;
				} else {
					console.log(suggestRes.msg);
				}
			},

			goNewsDet(item) {
				this.$router.push({ path: '/NewsDet', query: { id: item.id } });
			},

			goBookDet(info) {
				const { standardId, id, standardName, standardCode } = info;
				const targetRoute = this.$router.resolve({
					path: '/StandardsDet',
					query: { id: standardId || id }
				});
				window.open(targetRoute.href, '_blank');
			},

			// SEO：生成可爬取的详情页链接
			getBookHref(book) {
				const { standardId, id, standardName, standardCode } = book;
				return this.$router.resolve({
					path: '/StandardsDet',
					query: { id: standardId || id }
				}).href;
			},

			// SEO：注入热门标准结构化数据（Schema.org ItemList → Book）
			injectHotBooksSchema() {
				const existing = document.getElementById('hot-books-schema');
				if (existing) existing.remove();

				if (!this.hotBooks || !this.hotBooks.length) return;

				const schema = {
					'@context': 'https://schema.org',
					'@type': 'ItemList',
					name: '热门标准',
					description: '热门标准与法规图书',
					numberOfItems: this.hotBooks.length,
					itemListElement: this.hotBooks.map((book, index) => ({
						'@type': 'ListItem',
						position: index + 1,
						item: {
							'@type': 'Book',
							name: book.standardCode ? book.standardCode + ' ' + book.standardName : book.standardName,
							url: this.getBookHref(book),
							...(book.standardTypeName ? { genre: book.standardTypeName } : {}),
							...(book.effectiveDate ? { datePublished: book.effectiveDate } : {}),
							...(book.headAgency || book.implementAgency || book.issueAgency ? { publisher: { '@type': 'Organization', name: book.headAgency || book.implementAgency || book.issueAgency } } : {})
						}
					}))
				};

				const script = document.createElement('script');
				script.type = 'application/ld+json';
				script.id = 'hot-books-schema';
				script.textContent = JSON.stringify(schema);
				document.head.appendChild(script);
			},

			// SEO：生成新闻详情页链接
			getNewsHref(item) {
				return this.$router.resolve({
					path: '/NewsDet',
					query: { id: item.id }
				}).href;
			},

			// SEO：注入新闻结构化数据（Schema.org ItemList → NewsArticle）
			injectNewsSchema() {
				const existing = document.getElementById('news-schema');
				if (existing) existing.remove();

				if (!this.newsList || !this.newsList.length) return;

				const schema = {
					'@context': 'https://schema.org',
					'@type': 'ItemList',
					name: '新闻资讯',
					description: '行业动态 · 政策解读 · 标准更新',
					numberOfItems: this.newsList.length,
					itemListElement: this.newsList.map((item, index) => ({
						'@type': 'ListItem',
						position: index + 1,
						item: {
							'@type': 'NewsArticle',
							headline: item.newsTitle,
							url: this.getNewsHref(item),
							...(item.createTime ? { datePublished: item.createTime } : {})
						}
					}))
				};

				const script = document.createElement('script');
				script.type = 'application/ld+json';
				script.id = 'news-schema';
				script.textContent = JSON.stringify(schema);
				document.head.appendChild(script);
			},

			toApplyAccount() {
				this.$router.push('/ApplyAccount');
				// const targetRoute = this.$router.resolve({
				// 	path: '/index/applyAccount'
				// });
				// window.open(targetRoute.href, '_blank');
			},

			handleRoute(path) {
				if (path === '/BookCenter/BuyList') {
					if (!this.uisLogin) {
						this.setLoginShow(true);
					} else {
						this.$router.push(path);
					}
				} else {
					this.$router.push(path);
				}
			},

			openRegister() {
				this.setRegisterShow(true);
			},

			...mapActions('Settings', ['setLoginShow', 'setRegisterShow'])
		},
		components: {
			Theme,
			FriendLink
		}
	};
</script>

<style lang="less" scoped>
	// ========== 首页布局 - 匹配 lz_project ==========
	.home-page {
		background: #f8fafc;
	}

	.section-container {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 24px;
	}

	// ========== 核心服务卡片 ==========
	.section-services {
		position: relative;
		z-index: 1;
		margin-top: 34px;
		padding-bottom: 60px;
	}

	.services-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 24px;
	}

	.service-card {
		background: #ffffff;
		border-radius: 16px;
		padding: 28px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.04);
		border: 1px solid #f1f5f9;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
			border-color: #e2e8f0;
		}
	}

	.service-icon {
		width: 52px;
		height: 52px;
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 18px;
		transition: transform 0.3s ease;

		i {
			font-size: 26px;
			color: #ffffff;
		}

		.service-card:hover & {
			transform: scale(1.1);
		}
	}

	.service-title {
		font-size: 20px;
		font-weight: 700;
		color: #1e293b;
		margin: 0 0 8px;
	}

	.service-desc {
		font-size: 14px;
		color: #64748b;
		line-height: 1.6;
		margin: 0 0 20px;
	}

	.service-footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.service-stats {
		font-size: 12px;
		color: #94a3b8;
	}

	.service-link {
		font-size: 14px;
		color: #2563eb;
		font-weight: 500;
		display: flex;
		align-items: center;
		gap: 4px;
		transition: gap 0.2s;

		.service-card:hover & {
			gap: 8px;
		}
	}

	// ========== 数据统计 ==========
	.section-stats {
		padding-bottom: 60px;
	}

	.stats-box {
		background: linear-gradient(135deg, #2563eb, #4f46e5, #7c3aed);
		border-radius: 24px;
		padding: 48px 40px;
		color: #ffffff;
	}

	.stats-header {
		text-align: center;
		margin-bottom: 40px;

		h2 {
			font-size: 28px;
			font-weight: 700;
			margin: 0 0 8px;
		}

		p {
			font-size: 16px;
			color: #bfdbfe;
			margin: 0;
		}
	}

	.stats-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 24px;
		text-align: center;
	}

	.stat-item {
		i {
			font-size: 32px;
			opacity: 0.8;
			margin-bottom: 12px;
			display: block;
		}

		.stat-value {
			font-size: 32px;
			font-weight: 800;
			margin-bottom: 4px;
		}

		.stat-label {
			font-size: 14px;
			color: #bfdbfe;
		}
	}

	// ========== 为什么选择我们 ==========
	.section-why {
		padding-bottom: 80px;
	}

	.why-header {
		text-align: center;
		margin-bottom: 48px;

		h2 {
			font-size: 28px;
			font-weight: 700;
			color: #1e293b;
			margin: 0 0 12px;
		}

		p {
			font-size: 16px;
			color: #64748b;
			margin: 0;
		}
	}

	.why-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 24px;
	}

	.why-card {
		background: #ffffff;
		border-radius: 16px;
		padding: 32px 24px;
		text-align: center;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.04);
		border: 1px solid #f1f5f9;
		transition: box-shadow 0.3s ease;

		&:hover {
			box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
		}
	}

	.why-icon {
		width: 48px;
		height: 48px;
		border-radius: 12px;
		background: linear-gradient(135deg, #2563eb, #4f46e5);
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto 16px;

		i {
			font-size: 24px;
			color: #ffffff;
		}
	}

	.why-card h3 {
		font-size: 17px;
		font-weight: 700;
		color: #1e293b;
		margin: 0 0 8px;
	}

	.why-card p {
		font-size: 14px;
		color: #64748b;
		line-height: 1.6;
		margin: 0;
	}

	// ========== 新闻资讯 ==========
	.section-news {
		padding-bottom: 60px;
	}

	.news-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 24px;
	}

	.news-title-row {
		display: flex;
		align-items: center;
		gap: 14px;

		h2 {
			font-size: 24px;
			font-weight: 700;
			color: #1e293b;
			margin: 0 0 4px;
		}

		p {
			font-size: 14px;
			color: #64748b;
			margin: 0;
		}
	}

	.news-title-icon {
		font-size: 28px;
		color: #2563eb;
		background: linear-gradient(135deg, rgba(37, 99, 235, 0.15), rgba(79, 70, 229, 0.15));
		padding: 2px 11px;
		border-radius: 12px;
	}

	.news-list {
		background: #ffffff;
		border-radius: 16px;
		border: 1px solid #f1f5f9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.04);
		overflow: hidden;
	}

	.news-list-item {
	}

	.news-list-item-link {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 14px 22px;
		cursor: pointer;
		transition: background 0.2s ease;
		border-bottom: 1px dashed #f1f5f9;
		text-decoration: none;
		color: inherit;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background: #f8fafc;

			.news-list-title {
				color: #2563eb;
			}

			.news-list-icon {
				color: #2563eb;
			}
		}
	}

	.news-list-icon {
		font-size: 16px;
		color: #94a3b8;
		flex-shrink: 0;
		transition: color 0.2s ease;
	}

	.news-list-title {
		flex: 1;
		min-width: 0;
		font-size: 15px;
		color: #1e293b;
		font-weight: 500;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		transition: color 0.2s ease;
	}

	.news-list-time {
		flex-shrink: 0;
		font-size: 13px;
		color: #94a3b8;
	}

	// ========== 热门标准 ==========
	.section-hot {
		padding-bottom: 72px;
	}

	.hot-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 32px;
	}

	.hot-title-row {
		display: flex;
		align-items: center;
		gap: 14px;

		h2 {
			font-size: 24px;
			font-weight: 700;
			color: #1e293b;
			margin: 0 0 4px;
		}

		p {
			font-size: 14px;
			color: #64748b;
			margin: 0;
		}
	}

	.hot-title-icon {
		font-size: 28px;
		color: #f59e0b;
		background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(239, 68, 68, 0.15));
		padding: 2px 11px;
		border-radius: 12px;
	}

	.hot-view-all {
		font-size: 15px;
		color: #2563eb;
		font-weight: 500;
		transition: gap 0.2s;

		i {
			margin-left: 2px;
			transition: transform 0.2s;
		}

		&:hover {
			color: #1d4ed8;

			i {
				transform: translateX(3px);
			}
		}
	}

	.hot-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 24px;
	}

	// 列表式热门推荐
	.hot-list {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 12px 20px;
	}

	.hot-list-item {
		display: flex;
	}

	.hot-list-item-link {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 18px;
		background: #ffffff;
		border-radius: 14px;
		border: 1px solid #f1f5f9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		cursor: pointer;
		transition: all 0.25s ease;
		text-decoration: none;
		color: inherit;
		width: 100%;
		min-height: 118px;
		box-sizing: border-box;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
			border-color: #e2e8f0;

			.hot-list-title {
				color: #2563eb;
			}

			.hot-list-btn {
				background: #2563eb;
				border-color: #2563eb;
				color: #ffffff;
			}
		}
	}

	.hot-list-rank {
		width: 28px;
		height: 28px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		font-size: 14px;
		font-weight: 800;
		color: #94a3b8;
		background: #f1f5f9;

		&.rank-1 {
			color: #ffffff;
			background: linear-gradient(135deg, #ef4444, #f97316);
		}
		&.rank-2 {
			color: #ffffff;
			background: linear-gradient(135deg, #f59e0b, #f97316);
		}
		&.rank-3 {
			color: #ffffff;
			background: linear-gradient(135deg, #fbbf24, #f59e0b);
		}
	}

	.hot-list-img {
		width: 60px;
		height: 80px;
		border-radius: 8px;
		overflow: hidden;
		flex-shrink: 0;
		background: linear-gradient(135deg, #f1f5f9, #e2e8f0);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.hot-list-body {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.hot-list-title-row {
		display: flex;
		align-items: center;
		gap: 8px;
		// flex-wrap: wrap;
	}

	.hot-list-title {
		font-size: 14px;
		font-weight: 700;
		color: #1e293b;
		margin: 0;
		line-height: 1.4;
		word-break: break-word;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		transition: color 0.2s;
	}

	.hot-list-badge {
		flex-shrink: 0;
		background: linear-gradient(135deg, #ef4444, #f97316);
		color: #ffffff;
		font-size: 11px;
		font-weight: 600;
		padding: 2px 8px;
		border-radius: 4px;
	}

	.hot-list-desc {
		font-size: 12px;
		color: #94a3b8;
		margin: 0;
		line-height: 1.5;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.hot-list-impl-date {
		font-size: 12px;
		color: #64748b;
		font-weight: 500;
	}

	// 查看详情（span 模拟 el-button，位于 <a> 内部）
	.hot-list-btn {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		padding: 7px 15px;
		border-radius: 20px;
		background: rgba(37, 99, 235, 0.08);
		border: 1px solid rgba(37, 99, 235, 0.2);
		color: #2563eb;
		font-weight: 500;
		font-size: 12px;
		transition: all 0.2s;

		i {
			margin-left: 2px;
			font-size: 12px;
		}
	}

	.hot-card {
		background: #ffffff;
		border-radius: 16px;
		overflow: hidden;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.04);
		border: 1px solid #f1f5f9;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
			border-color: #e2e8f0;

			.hot-card-img img {
				transform: scale(1.05);
			}

			.hot-card-btn {
				background: #2563eb;
				border-color: #2563eb;
				color: #ffffff;
			}
		}
	}

	.hot-card-img {
		position: relative;
		height: 200px;
		overflow: hidden;
		background: linear-gradient(135deg, #f1f5f9, #e2e8f0);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: transform 0.4s ease;
		}
	}

	.hot-card-badge {
		position: absolute;
		top: 12px;
		left: 12px;
		background: linear-gradient(135deg, #ef4444, #f97316);
		color: #ffffff;
		font-size: 12px;
		font-weight: 600;
		padding: 4px 10px;
		border-radius: 6px;
	}

	.hot-card-body {
		padding: 20px;
	}

	.hot-card-category {
		font-size: 12px;
		color: #2563eb;
		background: rgba(37, 99, 235, 0.08);
		padding: 2px 10px;
		border-radius: 4px;
		font-weight: 500;
	}

	.hot-card-title {
		font-size: 14px;
		font-weight: 700;
		color: #1e293b;
		margin: 0 0 6px;
		line-height: 1.4;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		height: 42px;
	}

	.hot-card-desc {
		font-size: 12px;
		color: #94a3b8;
		margin: 0 0 16px;
		line-height: 1.5;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.hot-card-footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.hot-card-price {
		display: flex;
		align-items: baseline;
		gap: 8px;

		.price-current {
			font-size: 20px;
			font-weight: 800;
			color: #ef4444;
		}

		.price-origin {
			font-size: 12px;
			color: #94a3b8;
			text-decoration: line-through;
		}
	}

	.hot-card-btn {
		background: rgba(37, 99, 235, 0.08);
		border: 1px solid rgba(37, 99, 235, 0.2);
		color: #2563eb;
		font-weight: 500;
		transition: all 0.2s;
		font-size: 12px;
	}

	// ========== CTA 立即开始您的合规之旅 ==========
	.section-cta {
		// padding-bottom: 80px;
	}

	.cta-box {
		background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 40%, #312e81 100%);
		border-radius: 24px;
		padding: 64px 40px;
		position: relative;
		overflow: hidden;

		&::before {
			content: '';
			position: absolute;
			inset: 0;
			// background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Cpath d='M36 34v2H4v-2h32zm0-4v2H4v-4h32zm0-12vH4v-14h32z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
			opacity: 0.5;
		}
	}

	.cta-content {
		position: relative;
		text-align: center;
		color: #ffffff;

		h2 {
			font-size: 32px;
			font-weight: 800;
			margin: 0 0 16px;
			letter-spacing: -0.5px;
		}

		p {
			font-size: 17px;
			color: #cbd5e1;
			line-height: 1.7;
			max-width: 580px;
			margin: 0 auto 36px;
		}
	}

	.cta-actions {
		display: flex;
		justify-content: center;
		gap: 16px;
		flex-wrap: wrap;
	}

	.cta-btn-primary {
		background: linear-gradient(135deg, #2563eb, #4f46e5);
		color: #ffffff;
		border: none;
		font-weight: 600;
		font-size: 15px;
		padding: 14px 32px;
		border-radius: 12px !important;
		transition: all 0.2s;

		i {
			margin-right: 6px;
		}

		&:hover {
			background: linear-gradient(135deg, #1d4ed8, #4338ca);
			transform: translateY(-1px);
			box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
			color: #ffffff;
		}
	}

	.cta-btn-secondary {
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(10px);
		color: #ffffff;
		border: 1px solid rgba(255, 255, 255, 0.2);
		font-weight: 600;
		font-size: 15px;
		padding: 14px 32px;
		border-radius: 12px !important;
		transition: all 0.2s;

		i {
			margin-right: 6px;
		}

		&:hover {
			background: rgba(255, 255, 255, 0.2);
			transform: translateY(-1px);
			color: #ffffff;
		}
	}

	// ========== 响应式 ==========
	@media screen and (max-width: 767px) {
		.section-container {
			padding: 0 16px;
		}

		.services-grid,
		.stats-grid,
		.why-grid {
			grid-template-columns: 1fr;
			gap: 16px;
		}

		.section-services {
			// margin-top: -24px;
		}

		.stats-box {
			padding: 32px 20px;
			border-radius: 20px;
		}

		.stat-item .stat-value {
			font-size: 24px;
		}

		.why-header h2 {
			font-size: 24px;
		}

		.hot-grid {
			grid-template-columns: repeat(1, 1fr);
			gap: 16px;
		}

		.hot-list {
			grid-template-columns: 1fr;
			gap: 10px;
		}

		.hot-list-item-link {
			padding: 12px 14px;
			gap: 12px;
			min-height: 100px;
		}

		.hot-list-img {
			width: 50px;
			height: 66px;
		}

		.hot-list-btn {
			display: none;
		}

		.news-list-item-link {
			padding: 12px 16px;
			gap: 10px;
		}

		.news-list-title {
			font-size: 14px;
		}

		.news-list-time {
			font-size: 12px;
		}

		.hot-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 12px;
		}

		.cta-box {
			padding: 40px 20px;
			border-radius: 20px;
		}

		.cta-content h2 {
			font-size: 24px;
		}

		.cta-content p {
			font-size: 15px;
		}
	}

	@media screen and (min-width: 768px) and (max-width: 1024px) {
		.services-grid {
			grid-template-columns: repeat(3, 1fr);
			gap: 16px;
		}

		.stats-grid {
			grid-template-columns: repeat(2, 1fr);
		}

		.why-grid {
			grid-template-columns: repeat(2, 1fr);
		}

		.hot-grid {
			grid-template-columns: repeat(2, 1fr);
			gap: 20px;
		}

		.hot-list {
			grid-template-columns: 1fr;
			gap: 12px;
		}

		.cta-box {
			padding: 48px 32px;
		}
	}
</style>
